import { render } from "./Leaderboard.vue?vue&type=template&id=28924f0c&ts=true"
import script from "./Leaderboard.vue?vue&type=script&lang=ts"
export * from "./Leaderboard.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\callum\\Work\\edenic-game\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__